import type { TOC } from '@ember/component/template-only'
import PhosphorIcon from 'teacher-ui-client/components/phosphor-icon'
import { Tooltip } from 'teacher-ui-client/components/tooltip'

interface ChartTooltipSignature {
  Element: HTMLSpanElement
  Args: {
    text: string
  }
}

export const ChartTooltip: TOC<ChartTooltipSignature> = <template>
  <span class="z-tooltip absolute top-2 right-3 print:hidden" data-test-chart-tooltip ...attributes>
    <PhosphorIcon @icon="phosphor-info-fill" class="text-dusty-black-500 cursor-pointer" />
    <Tooltip @text={{@text}} data-test-tooltip />
  </span>
</template>
